import { actionCreator } from '@ardoq/rxbeach';
import {
  ViewpointModeViewKey,
  ViewpointModeViewSettingsShape,
  WorkspaceModeViewKey,
  WorkspaceModeViewSettingsShape,
} from './types';
import { ViewIds, ViewSettingsContexts } from '@ardoq/api-types';

type RequestViewSettingsUpdateBase = {
  readonly viewInstanceId?: string;
  readonly persistent: boolean;
  readonly settingsPath?: string[];
};

export type ViewpointModeViewSettingsUpdateRequestedPayload =
  RequestViewSettingsUpdateBase & {
    readonly viewId: ViewpointModeViewKey;
    readonly settings: Partial<
      ViewpointModeViewSettingsShape[ViewpointModeViewKey]
    >;
  };
export const viewpointModeViewSettingsUpdateRequested =
  actionCreator<ViewpointModeViewSettingsUpdateRequestedPayload>(
    '[viewSettingsActions] VIEW_SETTINGS_UPDATE_REQUESTED'
  );

export type WorkspaceModeViewSettingsUpdateRequestedPayload =
  RequestViewSettingsUpdateBase & {
    readonly viewId: WorkspaceModeViewKey;
    readonly settings: Partial<
      WorkspaceModeViewSettingsShape[WorkspaceModeViewKey]
    >;
  };
export const workspaceModeViewSettingsUpdateRequested =
  actionCreator<WorkspaceModeViewSettingsUpdateRequestedPayload>(
    '[viewSettingsActions] WORKSPACE_SETTINGS_UPDATE_REQUESTED'
  );

export type SaveViewSettingsChangePayload = {
  readonly contextId: ViewSettingsContexts;
  readonly viewId: ViewIds;
  readonly modifiedViewSettings: Record<string, any>;
  readonly changedProperties: [string | number, any][];
};
export const saveViewSettingsChange =
  actionCreator<SaveViewSettingsChangePayload>(
    '[viewSettingsActions] SAVE_AND_TRACK_VIEW_SETTINGS_CHANGE'
  );
